export default __webpack_public_path__ + "static/media/WorkSans-ExtraBold.780fcdcd.ttf";